interface Props {
  options?: {
    checked: string;
    unchecked: string;
  };
  icons?: {
    checked: string;
    unchecked: string;
  };
  value: boolean;
  onChange: (value: boolean) => void;
}

const ToggleInput = ({
  options = { checked: "Yes", unchecked: "No" },
  icons = { checked: "", unchecked: "" },
  value,
  onChange,
}: Props) => {
  return (
    <div
      style={{ width: "60px", height: "25px", border: "1px solid #ccc" }}
      className="rounded-pill cursor-pointer d-flex align-items-center p-1"
      onClick={() => onChange(!value)}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          transition: "0.3s",
          position: "relative",
          left: value ? undefined : "-3px",
          right: value ? "-35px" : undefined,
        }}
        className={`${
          value ? "bg-success" : "bg-lighter"
        } rounded-pill d-flex align-items-center justify-content-center`}
      >
        <i
          className={`${value ? icons.checked : icons.unchecked}  ${
            value && "text-white"
          }`}
        />
      </div>
      <span
        style={{
          position: "relative",
          left: !value ? "-2px" : "-18px",
          fontSize: "10px",
          fontWeight: "bold",
          transition: "0.2s",
        }}
      >
        {value ? options.checked : options.unchecked}
      </span>
    </div>
  );
};

export default ToggleInput;
